(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["date-booking"] && !Shopify.designMode) return;
  try {
    class BookingWidget extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('.booking__data');
      if (!dataEl) return;
      let cfg;
      try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
      const self = this;
      this.variants = (cfg.variants || []).filter(function (v) { return v.date && /^\d{4}-\d{2}-\d{2}$/.test(v.date); });
      this.i18n = cfg.i18n || {};
      this.duration = parseInt(this.getAttribute('data-duration'), 10) || 1;
      this.moneyFormat = this.getAttribute('data-money-format') || ('$' + '{' + '{amount}}');
      this.def = cfg.defaultVariant || null;
      this.deposit = cfg.deposit || null;
      this.payMode = 'full';
      this.horizon = parseInt(cfg.horizonDays, 10) || 90;
      // Open mode: no per-date variants → any future date within the horizon is bookable
      // on the default (full-price) variant; the date is sent as a line-item property.
      this.openMode = this.variants.length === 0;

      if (this.openMode && !this.def) {
        const form = this.querySelector('.booking__form');
        if (form) {
          const msg = document.createElement('p');
          msg.className = 'booking__empty';
          msg.textContent = this.i18n.noDates || '';
          form.replaceWith(msg);
        }
        return;
      }

      if (!this.openMode) {
        this.byDate = {};
        this.variants.forEach(function (v) { self.byDate[v.date] = v; });
      }

      this.selected = null;
      this.grid = this.querySelector('.booking__grid');
      this.label = this.querySelector('.booking__cal-label');
      this.cta = this.querySelector('.booking__cta');
      this.qtyInput = this.querySelector('.booking__qty');
      if (!this.grid) return;

      this.renderWeekdays();
      this.bindStatic();
      this.bindModes();

      if (this.openMode) {
        const t = new Date();
        this.viewY = t.getFullYear();
        this.viewM = t.getMonth();
        this.minMonth = this.monthKey(t);
        const end = new Date();
        end.setDate(end.getDate() + this.horizon);
        this.maxMonth = this.monthKey(end);
        this.horizonEnd = end.getFullYear() + '-' + this.pad(end.getMonth() + 1) + '-' + this.pad(end.getDate());
      } else {
        // Start on the month of the first available (or first) date, not before today.
        const dates = this.variants.map(function (v) { return v.date; }).sort();
        const first = dates.find(function (d) { return self.byDate[d].available && d >= self.today(); }) || dates[0];
        const fd = this.parse(first);
        this.viewY = fd.getFullYear();
        this.viewM = fd.getMonth();
        this.minMonth = this.monthKey(this.parse(dates[0]));
        this.maxMonth = this.monthKey(this.parse(dates[dates.length - 1]));
      }
      this.render();
    }

    today() {
      const d = new Date();
      return d.getFullYear() + '-' + this.pad(d.getMonth() + 1) + '-' + this.pad(d.getDate());
    }
    pad(n) { return (n < 10 ? '0' : '') + n; }
    parse(s) { const p = String(s).split('-'); return new Date(+p[0], (+p[1] || 1) - 1, +p[2] || 1); }
    monthKey(d) { return d.getFullYear() * 12 + d.getMonth(); }

    formatMoney(cents) {
      const amount = (cents / 100);
      const hasDecimals = /\{\{\s*amount\s*\}\}/.test(this.moneyFormat);
      let num;
      if (hasDecimals) num = amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      else num = Math.round(amount).toLocaleString();
      return this.moneyFormat.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, num);
    }

    renderWeekdays() {
      const wk = (this.i18n.weekdays || 'Su,Mo,Tu,We,Th,Fr,Sa').split(',');
      const host = this.querySelector('.booking__weekdays');
      host.innerHTML = wk.map(function (w) { return '<span>' + w.trim() + '</span>'; }).join('');
    }

    bindStatic() {
      const self = this;
      this.querySelector('.booking__prev').addEventListener('click', function () { self.shift(-1); });
      this.querySelector('.booking__next').addEventListener('click', function () { self.shift(1); });
      this.querySelector('.booking__minus').addEventListener('click', function () { self.bumpQty(-1); });
      this.querySelector('.booking__plus').addEventListener('click', function () { self.bumpQty(1); });
    }

    // Payment-mode radios (full / deposit). Only present when the product has a deposit variant.
    bindModes() {
      const self = this;
      const radios = this.querySelectorAll('.booking__mode-input');
      if (!radios.length || !this.deposit) return;
      radios.forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) self.setMode(r.value); });
      });
    }

    setMode(mode) {
      this.payMode = (mode === 'deposit' && this.deposit) ? 'deposit' : 'full';
      const self = this;
      this.querySelectorAll('.booking__mode').forEach(function (lab) {
        const input = lab.querySelector('.booking__mode-input');
        lab.classList.toggle('booking__mode--on', !!(input && input.value === self.payMode));
      });
      const modeProp = this.querySelector('.booking__prop-mode');
      const balProp = this.querySelector('.booking__prop-balance');
      if (modeProp) modeProp.value = this.payMode === 'deposit' ? (this.i18n.propModeDeposit || '定金') : (this.i18n.propModeFull || '全款');
      if (balProp) balProp.disabled = this.payMode !== 'deposit';
      if (this.selected) {
        this.querySelector('.booking__variant-id').value = this.chargedVariant().id;
      }
      this.updateTotal();
    }

    // The variant that actually gets charged: deposit variant in deposit mode, else the date/default variant.
    chargedVariant() {
      if (this.openMode) return (this.payMode === 'deposit' && this.deposit) ? this.deposit : this.def;
      return this.byDate[this.selected];
    }

    shift(dir) {
      let key = this.viewY * 12 + this.viewM + dir;
      if (key < this.minMonth || key > this.maxMonth) return;
      this.viewY = Math.floor(key / 12);
      this.viewM = key % 12;
      this.render();
    }

    render() {
      const months = (this.i18n.months || 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec').split(',');
      this.label.textContent = this.viewY + ' · ' + (months[this.viewM] || '').trim();
      const curKey = this.viewY * 12 + this.viewM;
      this.querySelector('.booking__prev').disabled = curKey <= this.minMonth;
      this.querySelector('.booking__next').disabled = curKey >= this.maxMonth;

      const firstDow = new Date(this.viewY, this.viewM, 1).getDay();
      const daysIn = new Date(this.viewY, this.viewM + 1, 0).getDate();
      const today = this.today();
      const self = this;
      let html = '';
      for (let i = 0; i < firstDow; i++) html += '<span class="booking__day booking__day--empty"></span>';
      for (let d = 1; d <= daysIn; d++) {
        const iso = self.viewY + '-' + self.pad(self.viewM + 1) + '-' + self.pad(d);
        let cls = 'booking__day', attr = '';
        if (self.openMode) {
          if (iso < today) { cls += ' booking__day--past'; }
          else if (iso <= self.horizonEnd) { cls += ' booking__day--ok'; attr = ' data-date="' + iso + '" role="button" tabindex="0"'; }
          else { cls += ' booking__day--none'; }
        } else {
          const v = self.byDate[iso];
          if (!v) { cls += ' booking__day--none'; }
          else if (iso < today) { cls += ' booking__day--past'; }
          else if (v.available) { cls += ' booking__day--ok'; attr = ' data-date="' + iso + '" role="button" tabindex="0"'; }
          else { cls += ' booking__day--out'; attr = ' title="' + (self.i18n.soldOut || '') + '"'; }
        }
        if (self.selected === iso) cls += ' booking__day--sel';
        html += '<button type="button" class="' + cls + '"' + attr + '>' + d + '</button>';
      }
      this.grid.innerHTML = html;
      this.grid.querySelectorAll('[data-date]').forEach(function (el) {
        el.addEventListener('click', function () { self.pick(el.getAttribute('data-date')); });
      });
    }

    pick(iso) {
      this.selected = iso;
      const v = this.openMode ? this.def : this.byDate[iso];
      this.querySelector('.booking__variant-id').value = this.chargedVariant().id;
      this.querySelector('.booking__prop-start').value = iso;

      // Multi-day end date = start + (duration - 1)
      const endEl = this.querySelector('.booking__prop-end');
      const datesRow = this.querySelector('.booking__row--dates');
      const datesVal = this.querySelector('.booking__dates-val');
      if (this.duration > 1) {
        const s = this.parse(iso);
        s.setDate(s.getDate() + (this.duration - 1));
        const end = s.getFullYear() + '-' + this.pad(s.getMonth() + 1) + '-' + this.pad(s.getDate());
        endEl.value = end; endEl.disabled = false;
        datesRow.hidden = false; datesVal.textContent = iso + ' → ' + end;
      } else {
        endEl.value = ''; endEl.disabled = true;
        datesRow.hidden = false; datesVal.textContent = iso;
      }

      // Seats + qty cap
      this.maxQty = (v.tracked && v.inventory > 0) ? v.inventory : 99;
      const seatsEl = this.querySelector('.booking__seats');
      if (v.tracked && v.inventory > 0 && v.inventory <= 10) {
        seatsEl.textContent = (this.i18n.seatsLeft || '__N__ left').replace('__N__', v.inventory);
      } else { seatsEl.textContent = ''; }
      let q = parseInt(this.qtyInput.value, 10) || 1;
      if (q > this.maxQty) q = this.maxQty;
      this.qtyInput.value = q;

      this.querySelector('.booking__pp-val').textContent = v.priceMoney;
      this.cta.disabled = false;
      this.cta.textContent = this.cta.getAttribute('data-book');
      this.querySelector('.booking__minus').disabled = (parseInt(this.qtyInput.value, 10) || 1) <= 1;
      this.render();
      this.updateTotal();
    }

    bumpQty(dir) {
      if (!this.selected) return;
      let q = (parseInt(this.qtyInput.value, 10) || 1) + dir;
      if (q < 1) q = 1;
      if (this.maxQty && q > this.maxQty) q = this.maxQty;
      this.qtyInput.value = q;
      this.querySelector('.booking__minus').disabled = q <= 1;
      this.querySelector('.booking__plus').disabled = this.maxQty ? q >= this.maxQty : false;
      this.updateTotal();
    }

    updateTotal() {
      if (!this.selected) return;
      const v = this.openMode ? this.def : this.byDate[this.selected];
      const q = parseInt(this.qtyInput.value, 10) || 1;
      const totalLabel = this.querySelector('.booking__total-label');
      const balanceRow = this.querySelector('.booking__row--balance');
      const balanceVal = this.querySelector('.booking__balance-val');
      if (this.openMode && this.payMode === 'deposit' && this.deposit) {
        // Deposit per traveller today; the balance (full − deposit) × travellers is paid on the day.
        this.querySelector('.booking__total-val').textContent = this.formatMoney(this.deposit.price * q);
        if (totalLabel) totalLabel.textContent = this.i18n.payToday || totalLabel.textContent;
        if (balanceRow) { balanceRow.hidden = false; balanceVal.textContent = this.formatMoney(this.deposit.balance * q); }
      } else {
        this.querySelector('.booking__total-val').textContent = this.formatMoney(v.price * q);
        if (totalLabel) totalLabel.textContent = this.i18n.total || totalLabel.textContent;
        if (balanceRow) balanceRow.hidden = true;
      }
    }
  }
  if (!customElements.get('booking-widget')) customElements.define('booking-widget', BookingWidget);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["line-dialog"] && !Shopify.designMode) return;
  try {
    (function () {
    function dlg() { return document.getElementById('line-dialog'); }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-line-open]');
      if (opener) {
        var d = dlg();
        if (d && typeof d.showModal === 'function') { e.preventDefault(); d.showModal(); }
        return;
      }
      var copy = e.target.closest('.line-dialog__copy');
      if (copy) {
        var done = function () { copy.textContent = copy.getAttribute('data-copied'); };
        var text = copy.getAttribute('data-copy');
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, done);
        else done();
        return;
      }
      var d2 = dlg();
      if (d2 && e.target === d2) d2.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-selectors"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.js-loc-selectors select').forEach(function (select) {
    select.addEventListener('change', function () {
      if (this.form) this.form.submit();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tour-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-tour-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('#tour-gallery-main, .tour-gallery__main-img');
    gallery.querySelectorAll('.tour-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (main && full) {
          // main image carries a srcset (responsive widths); the browser ignores .src while srcset is set, so drop it to force the swap
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = full;
        }
        gallery.querySelectorAll('.tour-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
